import { Component, OnInit } from '@angular/core';
import { FieldOkDefinition } from '../../../../data/definitions';
import { DynamicInputAtom } from '../dynamic-input-atom';

import {
  FieldValidationDirective,
  UiCorePipesModule,
  ValueConverterDirective,
} from '@softline/ui-core';
import { ReactiveFormsModule } from '@angular/forms';
import { FormControlPipe } from '../../../../pipes/form-control-name.pipe';
import {
  BooleanRulePipe,
  FieldOkComponent,
  FormatRulePipe,
  ResolveParametersPipe,
  ResultMappingConverterPipe,
} from '@softline/dynamic';

@Component({
  selector: 'soft-dynamic-field-ok-input',
  templateUrl: './field-ok-input.component.html',
  styleUrls: ['./field-ok-input.component.css'],
  imports: [
    ValueConverterDirective,
    ReactiveFormsModule,
    FieldValidationDirective,
    FormControlPipe,
    BooleanRulePipe,
    ResultMappingConverterPipe,
    FieldOkComponent,
    ResolveParametersPipe,
    FormatRulePipe,
    UiCorePipesModule
],
})
export class FieldOkInputComponent
  extends DynamicInputAtom<FieldOkDefinition>
  implements OnInit
{
  constructor() {
    super();
  }

  ngOnInit(): void {}
}
